module.exports = __webpack_public_path__ + "img/address.e11a8e96.png";